var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00065 2.66699C2.52789 2.66699 1.33398 3.8609 1.33398 5.33366V11.3337C1.33398 12.4382 2.22942 13.3337 3.33398 13.3337H9.33398H10.0007H10.6673H12.6673C13.7719 13.3337 14.6673 12.4382 14.6673 11.3337V8.66699C14.6673 7.19423 13.4734 6.00032 12.0007 6.00032H10.6673V5.33366C10.6673 3.8609 9.47341 2.66699 8.00065 2.66699H4.00065ZM10.6673 7.33366V12.0003H12.6673C13.0355 12.0003 13.334 11.7018 13.334 11.3337V8.66699C13.334 7.93061 12.737 7.33366 12.0007 7.33366H10.6673ZM9.33398 6.00032V5.33366C9.33398 4.59728 8.73703 4.00033 8.00065 4.00033H4.00065C3.26427 4.00033 2.66732 4.59728 2.66732 5.33366V11.3337C2.66732 11.7018 2.96579 12.0003 3.33398 12.0003H9.33398V6.66699V6.00032Z",
    fill: "#ffbb00",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 11.3337C4.66602 10.9655 4.96449 10.667 5.33268 10.667H6.66602C7.03421 10.667 7.33268 10.9655 7.33268 11.3337V13.3337H4.66602V11.3337Z",
    fill: "#ffbb00",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.33301C5.63181 5.33301 5.33333 5.63148 5.33333 5.99967V6.66634H4.66667C4.29848 6.66634 4 6.96482 4 7.33301C4 7.7012 4.29848 7.99967 4.66667 7.99967H5.33333V8.66634C5.33333 9.03453 5.63181 9.33301 6 9.33301C6.36819 9.33301 6.66667 9.03453 6.66667 8.66634V7.99967H7.33333C7.70152 7.99967 8 7.7012 8 7.33301C8 6.96482 7.70152 6.66634 7.33333 6.66634L6.66667 6.66634V5.99967C6.66667 5.63148 6.36819 5.33301 6 5.33301Z",
    fill: "#ffbb00",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.9f2ac0bf98974a7b5f7c9ce0e778da81.svg";
export { ForwardRef as ReactComponent };